import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { apiUrl } from "../lib/api";

const liveQueryKeys = [
  "dashboard-overview",
  "dashboard-chart",
  "payments",
  "payment-links",
  "seller-sales",
  "customers",
  "invoices",
  "notifications",
] as const;

export function LiveDataSync() {
  const client = useQueryClient();

  useEffect(() => {
    const refreshLiveData = () => {
      for (const key of liveQueryKeys) void client.invalidateQueries({ queryKey: [key], refetchType: "active" });
    };

    const stream = new EventSource(apiUrl("/events"), { withCredentials: true });
    stream.addEventListener("activity", refreshLiveData);

    const refreshAfterBackground = () => {
      if (document.visibilityState === "visible") refreshLiveData();
    };
    document.addEventListener("visibilitychange", refreshAfterBackground);

    return () => {
      stream.removeEventListener("activity", refreshLiveData);
      stream.close();
      document.removeEventListener("visibilitychange", refreshAfterBackground);
    };
  }, [client]);

  return null;
}
